import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { openSendPopupForContact, openSendPopupForContactWithEventType } from './slice'

export const SendFromCalendlyWrapper = ({
  contact,
  source,
  trackingSource,
  requestId,
  prefilledSubject,
  prefilledBody,
  eventType
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (eventType) {
      dispatch(openSendPopupForContactWithEventType({
        contact,
        source,
        trackingSource,
        requestId,
        prefilledSubject,
        prefilledBody,
        eventType
      }))
    } else {
      dispatch(openSendPopupForContact({
        contact,
        source,
        trackingSource,
        requestId,
        prefilledSubject,
        prefilledBody
      }))
    }
  }, [dispatch, contact, source, trackingSource, requestId, prefilledSubject, prefilledBody, eventType])

  return null
}
